import React from 'react';
import T from 'prop-types';
import { remove } from 'lodash-es';
import RatingCountry from './RatingCountry';

const RatingCountries = ({ countries, metric, count = 3 }) => {
  const normalizedData = () => {
    if (countries.length) {
      const filteredData = countries.filter(({ percentage_of }) => percentage_of > 0);
      const other = remove(filteredData, ({ country_iso }) => country_iso === 'other');
      return filteredData.slice(0, count).concat(other || []);
    }
    return [];
  };

  const data = normalizedData();

  return (
    <div className="rating-countries">
      {data.map(item => <RatingCountry key={item.country_iso} country={item} metric={metric} />)}
    </div>
  );
};

RatingCountries.propTypes = {
  countries: T.array.isRequired,
  count: T.number,
  metric: T.string,
};

export default RatingCountries;
